import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { socketService } from "../../../services/socket";

/**
 * Global logger settings. The relay (capture/STT) is configured from its own
 * web UI in the external relay service — only braindog-side settings live here.
 */
export const LoggerSettingsPanel: React.FC = () => {
  const { t } = useTranslation();
  const [loggerOffset, setLoggerOffset] = useState<number>(3);

  useEffect(() => {
    socketService.emit("get-logger-config", (config: any) => {
      if (config && config.loggerOffset !== undefined) {
        setLoggerOffset(config.loggerOffset);
      }
    });
  }, []);

  const handleChange = (value: number) => {
    setLoggerOffset(value);
    socketService.emit("admin:sync_logger_config", { loggerOffset: value });
  };

  return (
    <div style={{ padding: "24px", color: "#fff" }}>
      <h2 style={{ fontSize: "1.5rem", marginBottom: "8px", color: "var(--color-accent)" }}>
        <i className="bx bx-time"></i> {t("admin.loggerSettings.title")}
      </h2>
      <p style={{ color: "#aaa", fontSize: "0.9rem", marginBottom: "24px" }}>
        {t("admin.loggerSettings.description")}
      </p>

      <div
        style={{
          background: "rgba(0,0,0,0.3)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "480px",
        }}
      >
        <label
          style={{
            fontSize: "0.8rem",
            color: "#ccc",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <span>{t("admin.loggerSettings.offsetLabel")}</span>
          <span style={{ color: "var(--color-brand)", fontWeight: 700 }}>{loggerOffset}s</span>
        </label>
        <input
          type="range"
          min={0}
          max={10}
          step={1}
          value={loggerOffset}
          onChange={(e) => handleChange(parseInt(e.target.value))}
          style={{ width: "100%", accentColor: "var(--color-brand)" }}
        />
        <div style={{ fontSize: "0.7rem", color: "#555", marginTop: "6px", fontStyle: "italic" }}>
          {t("admin.loggerSettings.offsetHint")}
        </div>
      </div>
    </div>
  );
};
